<template>
  <v-data-table
    :headers="headers"
    :items="records"
    item-key="nomenklatura_id"
    hide-actions
  >
    <template slot="items" slot-scope="props">
      <tr>
        <td class="justify-center layout px-0" v-if="parseInt(props.item.sborniy_tovar)">
          <v-icon
            small
            @click="$emit('openOptionsDialog', props.item)"
          >
            mdi-settings
          </v-icon>
        </td>
        <td class="text-xs-right">{{ props.item.nomenklatura_id }}</td>
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right" style="text-align: right">
          <input
            v-model.number="props.item.kolichestvo"
            @focus="$event.target.select()"
            type="number"
            min="1"
            v-numericOnly
            pattern="\d*"
            class="table-qty">
        </td>
        <td class="text-xs-right">{{ props.item.rezerv }}</td>
        <td class="text-xs-right">{{ props.item.tsena }}</td>
        <td class="text-xs-right">{{ (props.item.tsena * props.item.rezerv) | numberFormat(2, '.', ' ') }}</td>
        <td class="text-xs-left">
          <v-tooltip bottom>
            <v-icon
              slot="activator"
              color="red"
              @click="deleteRow(props.item)"
            >
              mdi-delete
            </v-icon>
            <span>Удалить</span>
          </v-tooltip>
        </td>
      </tr>
    </template>
    <template slot="footer">
      <td colspan="100%" class="text-xs-right">
        Итого: <strong>{{ documentSumma | numberFormat(2, '.', ' ') }}</strong>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { numericOnly } from '@/directives/numericOnly'
import numberFormat from '@/filters/numberFormat'
export default {
  name: 'rezervirovanieTable',
  props: {
    records: {
      default: () => [],
      required: true,
      type: Array
    }
  },
  directives: {
    numericOnly
  },
  filters: {
    numberFormat
  },
  data () {
    return {
    }
  },
  computed: {
    headers () {
      let headers = [
        {
          text: 'Код',
          align: 'right',
          width: '100px',
          value: 'nomenklatura_id'
        },
        {
          text: 'Наименование',
          align: 'left',
          value: 'name'
        },
        {
          text: 'К-во',
          align: 'right',
          width: '100px',
          value: 'kolichestvo'
        },
        {
          text: 'Резерв',
          align: 'right',
          width: '100px',
          value: 'rezerv'
        },
        {
          text: 'Цена',
          width: '120px',
          align: 'right',
          value: 'tsena'
        },
        {
          text: 'Сумма',
          width: '120px',
          align: 'right',
          value: 'summa'
        },
        {
          text: '',
          align: 'center',
          width: '45px',
          value: 'actions',
          sortable: false
        }
      ]

      if (this.records.length > 0 && parseInt(this.records[0].sborniy_tovar)) {
        headers.unshift(
          {
            sortable: false,
            width: 60
          }
        )
      }

      return headers
    },
    documentSumma () {
      let summa = 0
      this.records.forEach(function (v) {
        summa += parseFloat(v.tsena) * parseInt(v.rezerv)
      })

      return summa
    }
  },
  methods: {
    deleteRow (item) {
      this.$emit('deleteRow', item)
    }
  }
}
</script>

<style scoped>

</style>
